// extracted by mini-css-extract-plugin
module.exports = {"root":"PrimaryProductCard-module--root--2bzcx"};